import {ONBOARDING} from './types'

const verify = (data, history) =>({
    type: ONBOARDING.VERIFY,
    payload: data,
    history
})

const verifySuccess = (data) =>({
    type: ONBOARDING.VERIFY_SUCCESS,
    payload: data
})


const verifyFail = (data)=>({
    type: ONBOARDING.VERIFY_FAIL,
    payload: data
})


const submitDetails = (data, history) =>({
    type: ONBOARDING.SUBMIT_DETAILS,
    payload: data,
    history
})

const presubmitDetails = (data) =>({
    type: ONBOARDING.PRE_SUBMIT_DETAILS,
    payload: data
})

const submitDetailsFail = (data) =>({

    type: ONBOARDING.SUBMIT_DETAILS_FAIL,
    payload: data

})

const submitDetailsSuccess = (data) =>{
 return {type: ONBOARDING.SUBMIT_DETAILS_SUCCESS,
    payload: data}
}

const setPin = (data, history) => ({
    type: ONBOARDING.SET_PIN,
    payload: data,
    history
})

const setPinSuccess = (data) => ({
    type: ONBOARDING.SET_PIN_SUCCESS,
    payload:data
})

const setPinFail = (data) => ({
    type: ONBOARDING.SET_PIN_FAIL,
    payload:data
})

export {verify, verifySuccess, verifyFail, presubmitDetails,submitDetails, submitDetailsSuccess, submitDetailsFail, setPin, setPinSuccess, setPinFail}
